/**
 * Функция обертка для счетчика Яндекс.Метрики
 * так как в счетчеке захордокодено id счетчика yaCounterXXXXXX
 * то лучше использовать общую прослойку чтобы вызывать reachGoal
 * и в случае замены на новый счетчик не нужно было бы все менять в коде.
 * т.е плагин автоматически ищет яндекс счетчик с произвольным идентификатором
 * и регистрирует его в глобальном объекте window.yaCounter. теперь можно просто вызывать reachGoal
 */

/** очередь для хранения событий , если метрика не готова **/
const pendingGoals = [];

/** готова ли метрика или нет. **/
let isYandexReady = false;

/**
 * Попытка инициализировать window.yaCounter из глобального объекта.
 * Если счётчик не загружен — повторит maxAttempts попытки через setTimeout intervalMs мс.
 *
 * @param onSuccess Функция колбэк, вызываемая при успешной инициализации
 * @param onFalse Функция колбэк, вызываемая при неудачной инициализации
 * @param maxAttempts Кол-во попыток (по умолчанию 10)
 * @param intervalMs Интервал между попытками ретрая (по умолчанию 300 мс)
 */
export function initYandexMetrika(
    onSuccess = () => {
    }, onFalse = () => {
    },
    maxAttempts = 10, intervalMs = 300
) {
    let attempts = 0;

    window.sendYandexGoal = sendYandexGoal;
    // делаем доступной глобально. чтобы вызывать можно было без window
    eval(`var sendYandexGoal = window.sendYandexGoal`);

    const tryInit = () => {
        if (!window.yaCounter) {
            for (let key in window) {
                if (/^yaCounter\d+$/.test(key)) {
                    window.yaCounter = window[key];
                    // console.log('[Метрика] yaCounter инициализирован:', key);
                    break;
                }
            }
        }

        attempts++;

        if (window.yaCounter && typeof window.yaCounter.reachGoal === 'function') {
            isYandexReady = true;
            // Выполнить все отложенные цели
            while (pendingGoals.length > 0) {
                const {goalName, goalParams} = pendingGoals.shift();
                // console.log('pendingGoals', goalParams)
                sendYandexGoal(goalName, goalParams);
            }
            // если передали callback
            onSuccess();
        } else if (attempts < maxAttempts) {
            setTimeout(tryInit, intervalMs);
        } else {
            onFalse();
            console.warn('[Метрика] Не удалось инициализировать yaCounter после', attempts, 'попыток');
        }
    };

    tryInit();
}

/**
 * сама функция обертка
 * принимает имя цели и параметры, если счетчик не инициалихирован тогда сохраняет в очередь
 * для будущего выполнения
 */
export function sendYandexGoal(goalName, goalParams = {}) {
    try {
        // Вызов цели, если найден счётчик
        if (isYandexReady && window.yaCounter && typeof window.yaCounter.reachGoal === 'function') {
            window.yaCounter.reachGoal(goalName, goalParams);
            // console.log('[Метрика] reachGoal отправлена:', goalName, goalParams,  window.yaCounter);
        } else {
            pendingGoals.push({goalName, goalParams});
            // console.warn('[Метрика] Счётчик не найден или не готов. Откладываем задание');
        }
    } catch (e) {
        console.error('[Метрика] Ошибка при отправке цели:', goalName, goalParams, e);
    }
}